import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import { useContext } from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import Helper from "../../Helper";

const SidebarControlButton = () => {
    const context = useContext(GlobalStoreContext);

    const collapseSidebar = () => {
        const currentSidebarCollapse = context.collapseSidebar;
        context.setCollapseSidebar(!currentSidebarCollapse);
        const cookie = Helper.getCookie("userPreferences");
        if (!cookie) {
            Helper.setCookie("userPreferences", JSON.stringify({ collapseSidebar: !currentSidebarCollapse }));
        } else {
            let userPreferences;
            try {
                userPreferences = JSON.parse(cookie);
            } catch (e) {
                userPreferences = {};
            }
            userPreferences.collapseSidebar = !context.collapseSidebar;
            Helper.setCookie("userPreferences", JSON.stringify(userPreferences));
        }
    };

    return (
        <IconButton size="small" onClick={collapseSidebar}>
            {/* If you change the icon in the future you can use flip to control the horizontal direction
            in Fontawesome.
            flip={context.collapseSidebar && "horizontal"} */}

            <FontAwesomeIcon icon={faBars} color="#ff9e00" />
        </IconButton>
    );
};

export default SidebarControlButton;
